
import { Container, Stack } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

export function PageLoading(){
    return (
        <Container sx={{height: '100vh'}}>
            <Stack direction="row" justifyContent={'center'} alignItems={'center'} height={'100%'}>
                <CircularProgress />
            </Stack>
        </Container>
    )
}